import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

// One shared copy of the licence for every screen (refreshed at most once a minute).
let cache = null;
let at = 0;
let inflight = null;
const subs = new Set();

function publish(data) {
  cache = data;
  at = Date.now();
  subs.forEach((f) => f(data));
}

export function loadLicense(force = false) {
  if (!force && cache && Date.now() - at < 60000) return Promise.resolve(cache);
  if (!inflight) inflight = api.get("/license").then(({ data }) => { publish(data); return data; }).finally(() => { inflight = null; });
  return inflight;
}

export function setLicense(data) { publish(data); }

export function useLicense() {
  const [lic, setLic] = useState(cache);
  useEffect(() => {
    subs.add(setLic);
    loadLicense().catch(() => {});
    return () => { subs.delete(setLic); };
  }, []);
  const has = useCallback((flag) => !lic || Boolean(lic.flags?.[flag]), [lic]);
  return { lic, has };
}

export function contactUrl(lic) {
  const s = lic?.support || {};
  if (s.whatsapp) return `https://wa.me/${String(s.whatsapp).replace(/\D/g, "")}`;
  if (s.email) return `mailto:${s.email}`;
  return null;
}

export const PLAN_FEATURES = ["website_themes_all", "online_payments", "social_posting", "ai_creatives", "multi_branch", "whatsapp_crm"];
export const NEEDS = { website_themes_all: "growth", online_payments: "growth", social_posting: "growth", ai_creatives: "pro", multi_branch: "pro" };
